export enum SecurityProfileEnum {
    User = 0,
    Admin = 1,
    SuperAdmin = 2,
    None = 3
}
